import { render, staticRenderFns } from "./CardAdditional.vue?vue&type=template&id=8c066c68&scoped=true&"
import script from "./CardAdditional.vue?vue&type=script&lang=js&"
export * from "./CardAdditional.vue?vue&type=script&lang=js&"
import style0 from "./CardAdditional.vue?vue&type=style&index=0&id=8c066c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c066c68",
  null
  
)

export default component.exports